<div class="snackbar-wrap" ><span
    class="snackbar-content">{{statusMessage}}</span></div>


    <!-- [ngClass]="{'active':successMessage.length>0}" -->